module.exports = __webpack_public_path__ + "static/media/tire-exlamation.aec9e95a.svg";